@if (isLoading()) {
  <div class="flex flex-col gap-2 p-4">
    <palantir-skeleton class="w-full h-12 rounded-lg"></palantir-skeleton>
    <palantir-skeleton class="w-full h-12 rounded-lg"></palantir-skeleton>
  </div>
} @else {
  <div class="flex flex-col gap-4 p-24">
    @if (selectedItems().length) {
      @if (!readonly && hasPermission) {
        <div class="flex justify-end">
          <palantir-button theme="outline" layout="prefix" icon="add-outline" (click)="openSearchDialog()">
            {{ 'TAB_MAINTENANCE_PRODUCTS.BUTTON.LINK' | translate }}
          </palantir-button>
        </div>
      }
      <p class="field-dialog__content__scroll__title mb-4">
        {{ 'TAB_MAINTENANCE_PRODUCTS.ATTACHED_LABEL' | translate }} ({{ selectedItems().length }}/150)
      </p>
      <div class="items-table">
        <table class="items-table__content">
          <thead>
            <tr class="items-table__content__header-row">
              <th class="items-table__content__header-row__name">
                {{ 'TAB_MAINTENANCE_PRODUCTS.TABLE.NAME' | translate }}
              </th>
              @if (!readonly && hasPermission) {
                <th class="items-table__content__header-row__actions">
                  {{ 'TAB_MAINTENANCE_PRODUCTS.TABLE.ACTIONS' | translate }}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (item of paginatedItems(); track item.id) {
              <tr class="items-table__content__row">
                <td class="items-table__content__row__name">
                  <div class="items-table__content__row__name__thumbnail">
                    <palantir-icon name="package-outline"></palantir-icon>
                  </div>
                  <span class="items-table__content__row__name__label">{{ item.name }}</span>
                </td>
                @if (!readonly && hasPermission) {
                  <td class="items-table__content__row__actions">
                    <button class="items-table__content__row__actions__btn" (click)="removeItem(item.id)">
                      <palantir-icon name="delete-outline"></palantir-icon>
                    </button>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
        @if (selectedItems().length > pageSize) {
          <div class="items-table__navigation">
            <div class="items-table__navigation__text">
              <p>
                {{
                  'TAB_MAINTENANCE_PRODUCTS.TABLE.PAGINATION.TITLE'
                    | translate: { from: paginationFrom(), to: paginationTo(), total: selectedItems().length }
                }}
              </p>
            </div>
            <button class="items-table__navigation__btn-previous" (click)="toPreviousPage()" [disabled]="!hasPreviousPage()">
              {{ 'TAB_MAINTENANCE_PRODUCTS.TABLE.PAGINATION.PREVIOUS' | translate }}
            </button>
            <button class="items-table__navigation__btn-next" (click)="toNextPage()" [disabled]="!hasNextPage()">
              {{ 'TAB_MAINTENANCE_PRODUCTS.TABLE.PAGINATION.NEXT' | translate }}
            </button>
          </div>
        }
      </div>
    } @else {
      <div class="flex flex-col items-center justify-center h-[400px] gap-3">
        <div class="w-[160px] h-[160px] rounded-full bg-blue-50 flex items-center justify-center">
          <palantir-icon style="font-size: 100px" name="package-outline"></palantir-icon>
        </div>
        <palantir-text type="title" size="lg">
          {{ 'TAB_MAINTENANCE_PRODUCTS.EMPTY_STATE.TITLE' | translate }}
        </palantir-text>
        @if (!readonly && hasPermission) {
          <palantir-text type="description" size="xs">
            {{ 'TAB_MAINTENANCE_PRODUCTS.EMPTY_STATE.DESCRIPTION' | translate }}
          </palantir-text>
          <palantir-button theme="outline" layout="prefix" icon="add-outline" (click)="openSearchDialog()">
            {{ 'TAB_MAINTENANCE_PRODUCTS.BUTTON.LINK' | translate }}
          </palantir-button>
        }
      </div>
    }
  </div>
}
